<template>
    <div data-component="stratmk.overview.v12020" class="max">
        <v-layout justify-center align-center>
            overview route
        </v-layout>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data: () => {
        return {
            
        }
    }
}
</script>